import httpService from "./httpService";

export default {
    getAll: async () => {
        return await httpService.get('commitment-all');
    },
};
